<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin blueBg">
        <div class="inner">
            <h3>{{ $t('contact.edit.complate') }}</h3>

            <div class="textBox">
                {{ $t('contact.edit.thank') }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'contact-complate-module',

        created() {
            localStorage.removeItem('selection')
            localStorage.removeItem('subject')
            localStorage.removeItem('content')
        },
    }
</script>

<style>

</style>
